import { useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';

const INTERVAL_MS = 30000;

let sharedCount = 0;
const listeners = new Set();
let timer = null;

async function fetchUnread() {
  if (document.hidden) return;
  try {
    const response = await api.get('/notifications/unread-count', { withCredentials: true });
    sharedCount = response.data.count ?? 0;
    listeners.forEach((fn) => fn(sharedCount));
  } catch {
    // Keep last known count
  }
}

function onVisibility() {
  if (!document.hidden) fetchUnread();
}

function ensurePolling() {
  if (timer != null) return;
  fetchUnread();
  timer = setInterval(fetchUnread, INTERVAL_MS);
  document.addEventListener('visibilitychange', onVisibility);
}

function stopPollingIfIdle() {
  if (listeners.size === 0 && timer != null) {
    clearInterval(timer);
    timer = null;
    document.removeEventListener('visibilitychange', onVisibility);
  }
}

/**
 * One shared poll for `/notifications/unread-count` across Header, BottomNav, Sidebar, etc.
 */
export const useNotificationCount = () => {
  const [count, setCount] = useState(sharedCount);

  useEffect(() => {
    const listener = setCount;
    listeners.add(listener);
    listener(sharedCount);
    ensurePolling();
    return () => {
      listeners.delete(listener);
      stopPollingIfIdle();
    };
  }, []);

  const refetch = useCallback(async () => {
    await fetchUnread();
  }, []);

  return { count, refetch };
};
